import { LoadingIcon } from '../../../../components/Zen/LoadingIcon';
import styles from './style.m.less';

const LoadingIndicator = () => (
    <LoadingIcon>
        <g fillRule="evenodd">
            <path
                className={styles.border}
                d="M10,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,18 C0,19.1045695 0.8954305,20 2,20 L14,20 C15.1045695,20 16,19.1045695 16,18 L16,6 L10,0 Z"
                transform="translate(4 2)"
            />
            <path className={styles.latch} d="M10 0L10 6 16 6" transform="translate(4 2)" />
            <path
                className={styles.circle}
                d="M4.29317671 5.29317671C4.68307923 4.90227443 5.31592102 4.90227443 5.70682329 5.29317671 6.09772557 5.68407898 6.09772557 6.31592102 5.70682329 6.70682329 5.31592102 7.09772557 4.68307923 7.09772557 4.29317671 6.70682329 3.90227443 6.31592102 3.90227443 5.68407898 4.29317671 5.29317671z"
                transform="translate(4 2)"
            />
            <path className={styles.text1} d="M12 11L4 11" transform="translate(4 2)" />
            <path className={styles.text2} d="M12 15L4 15" transform="translate(4 2)" />
        </g>
    </LoadingIcon>
);

export default LoadingIndicator;
